import { Navigate, Route, Routes } from "react-router-dom";
import { Result } from "antd";
import { useTranslation } from "react-i18next";
import type { Azione } from "@qa/shared";
import { Protected } from "./auth/Protected";
import { AppLayout } from "./components/AppLayout";
import { usePuo } from "./lib/permessi";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import CruscottoPage from "./pages/redflag/CruscottoPage";
import SegnalazioniPage from "./pages/redflag/SegnalazioniPage";
import SegnalazionePage from "./pages/redflag/SegnalazionePage";
import NuovaSegnalazionePage from "./pages/redflag/NuovaSegnalazionePage";
import NcPage from "./pages/redflag/NcPage";
import AzioniPage from "./pages/redflag/AzioniPage";
import ReportPage from "./pages/redflag/ReportPage";
import ClaimPage from "./pages/claim/ClaimPage";
import ClaimSchedaPage from "./pages/claim/ClaimSchedaPage";
import FornitoriPage from "./pages/claim/FornitoriPage";
import FornitorePage from "./pages/claim/FornitorePage";
import PropostePage from "./pages/PropostePage";
import AccessiPage from "./pages/admin/AccessiPage";
import ListePage from "./pages/admin/ListePage";
import RegistroPage from "./pages/admin/RegistroPage";
import SfCasiPage from "./pages/admin/SfCasiPage";
import SfCasoPage from "./pages/admin/SfCasoPage";

/** Una pagina che serve un permesso: senza, un messaggio (il menu non la mostra già). */
function Serve({ a, children }: { a: Azione; children: React.ReactNode }) {
  const puo = usePuo();
  const { t } = useTranslation();
  return puo(a) ? <>{children}</> : <Result status="403" subTitle={t("errore.nonConsentito")} />;
}

function NonTrovata() {
  const { t } = useTranslation();
  return <Result status="404" subTitle={t("errore.nonTrovata")} />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <Protected>
            <AppLayout />
          </Protected>
        }
      >
        <Route index element={<HomePage />} />
        <Route path="redflag" element={<Serve a="rf.vedi"><CruscottoPage /></Serve>} />
        <Route path="redflag/segnalazioni" element={<Serve a="rf.vedi"><SegnalazioniPage /></Serve>} />
        <Route path="redflag/segnalazioni/nuova" element={<Serve a="rf.crea"><NuovaSegnalazionePage /></Serve>} />
        <Route path="redflag/segnalazioni/:id" element={<Serve a="rf.vedi"><SegnalazionePage /></Serve>} />
        <Route path="redflag/azioni" element={<Serve a="rf.vedi"><AzioniPage /></Serve>} />
        <Route path="redflag/nc/:id" element={<Serve a="nc.vedi"><NcPage /></Serve>} />
        <Route path="redflag/report" element={<Serve a="report.vedi"><ReportPage /></Serve>} />
        <Route path="claim" element={<Serve a="claim.vedi"><ClaimPage /></Serve>} />
        <Route path="claim/:id" element={<Serve a="claim.vedi"><ClaimSchedaPage /></Serve>} />
        <Route path="fornitori" element={<Serve a="fornitore.vedi"><FornitoriPage /></Serve>} />
        <Route path="fornitori/:id" element={<Serve a="fornitore.vedi"><FornitorePage /></Serve>} />
        <Route path="proposte" element={<Serve a="proposta.crea"><PropostePage /></Serve>} />
        <Route path="admin" element={<Navigate to="/admin/accessi" replace />} />
        <Route path="admin/accessi" element={<Serve a="admin"><AccessiPage /></Serve>} />
        <Route path="admin/liste" element={<Serve a="admin"><ListePage /></Serve>} />
        <Route path="admin/registro" element={<Serve a="admin"><RegistroPage /></Serve>} />
        <Route path="admin/sf" element={<Serve a="admin"><SfCasiPage /></Serve>} />
        <Route path="admin/sf/:id" element={<Serve a="admin"><SfCasoPage /></Serve>} />
        <Route path="*" element={<NonTrovata />} />
      </Route>
    </Routes>
  );
}
